module.exports = __webpack_public_path__ + "static/media/ZuInformationszweckenGs.0cf48e0e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/ZuInformationszweckenGs.pdf
// module id = 1520
// module chunks = 0